export { default as NewCustomerPermission } from './NewCustomerPermission';
